import api from '../lib/api';
import type { QuickCopy, QuickCopyInput } from '../types/quickCopy';

class QuickCopyService {
  async createQuickCopy(data: QuickCopyInput): Promise<QuickCopy> {
    const response = await api.post('/quick-copy', data);
    return response.data;
  }

  async getQuickCopyByPublicKey(publicKey: string): Promise<QuickCopy> {
    const response = await api.get(`/quick-copy/${publicKey}`);
    return response.data;
  }
}

export default new QuickCopyService();
